import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Login from "./pages/Login";
import SetupPassword from "./pages/SetupPassword";
import AdminPortal from "./portals/AdminPortal";
import ManagerPortal from "./portals/ManagerPortal";
import WorkerPortal from "./portals/WorkerPortal";
import ReviewPortal from "./portals/ReviewPortal";

const Router = () => {
  const { auth } = useAuth();
  if (!auth) return <Login />;
  if (auth.role === "admin") return <AdminPortal />;
  if (auth.role === "manager") return <ManagerPortal />;
  if (auth.role === "worker") return <WorkerPortal />;
  if (auth.role === "review") return <ReviewPortal />;
  return <Login />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/setup/:token" element={<SetupPassword />} />
          <Route path="*" element={<Router />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
